<section
  (click)="onAppClicked()"
  class="app-container"
>
  <div class="left-part">
    <icon [app]="app()" [displayType]="DisplayType.SMALL" />
  </div>

  <div class="right-part">
    <div
      class="label"
      [toolTipElementRef]="label"
      [tooltip]="app().title!"
      #label
    >
      <div>
        <a class="title line-clamp-2"> {{ app().title }} </a>
        <a class="subtitle line-clamp-1"> {{ getAppContainerName }} </a>
      </div>
    </div>
  </div>
</section>